import apiZervant from '../../../../../../utils/apiZervant'
import { EInvoiceAddressSchemeTypeList } from './types/eInvoiceAddressSchemeTypeList'

interface FetchEInvoiceAddressSchemeTypeListResponse {
  data: EInvoiceAddressSchemeTypeList
}

export const fetchEInvoiceAddressSchemeTypeList = async (): Promise<FetchEInvoiceAddressSchemeTypeListResponse> => {
  return await apiZervant.invoiceDelivery.get('/einvoice/addressTypes')
}
